import { v4 as uuidv4 } from 'uuid'
import { ActivityEnum } from './Enums'

import { EthAddr, TxHash } from './SchemaTypes'

export enum WSServerActions {
  POOL_ACCOUNT_SUBSCRIBE = 'POOL_ACCOUNT_SUBSCRIBE',
  POOL_OVERVIEW_SUBSCRIBE = 'POOL_OVERVIEW_SUBSCRIBE',
  POOL_OVERVIEW_DATA = 'POOL_OVERVIEW_DATA',
  POOL_TX = 'POOL_TX',
  POOL_TX_REQUEST = 'POOL_TX_REQUEST',
  BALANCE_REFRESH = 'BALANCE_REFRESH',
  CLOCK_REFRESH = 'CLOCK_REFRESH',
}
export const txUUID = (): string => {
  return uuidv4()
}

export type WSServerAction = {
  action: WSServerActions
  chainConfigurationName: string
}

export type WSServerActionPoolOverviewSubscribe = WSServerAction & {
  action: WSServerActions.POOL_OVERVIEW_SUBSCRIBE
}

export function wsServerActionPoolOverviewSubscribe(chainConfigurationName: string): string {
  const action: WSServerActionPoolOverviewSubscribe = {
    action: WSServerActions.POOL_OVERVIEW_SUBSCRIBE,
    chainConfigurationName,
  }
  return JSON.stringify(action)
}

export type WSServerActionPoolAccountSubscribe = WSServerAction & {
  action: WSServerActions.POOL_ACCOUNT_SUBSCRIBE
  accountAddr: EthAddr
}

export function wsServerActionAccountSubscribeAction(accountAddr: EthAddr, chainConfigurationName: string): string {
  const action: WSServerActionPoolAccountSubscribe = {
    action: WSServerActions.POOL_ACCOUNT_SUBSCRIBE,
    accountAddr,
    chainConfigurationName,
  }
  console.log('wsServerActionAccountSubscribeAction', action)
  return JSON.stringify(action)
}

export type WSServerActionPoolTXRequest = WSServerAction & {
  activity: ActivityEnum
  action: WSServerActions.POOL_TX_REQUEST
  poolAddr: EthAddr
  uuid: string
}

export function wsServerActionPoolTXRequest(
  activity: ActivityEnum,
  poolAddr: EthAddr,
  uuid: string,
  chainConfigurationName: string
): string {
  const action: WSServerActionPoolTXRequest = {
    activity,
    action: WSServerActions.POOL_TX_REQUEST,
    poolAddr,
    uuid,
    chainConfigurationName,
  }
  return JSON.stringify(action)
}

export type WSServerActionPoolTX = WSServerAction & {
  action: WSServerActions.POOL_TX
  activity: ActivityEnum
  poolAddr: EthAddr
  uuid: string
  txHash: TxHash
  offChainData?: Record<string, any>
}

export function wsServerActionPoolTX(
  activity: ActivityEnum,
  poolAddr: EthAddr,
  uuid: string,
  txHash: TxHash,
  chainConfigurationName: string,
  offChainData?: Record<string, any>
): string {
  const action: WSServerActionPoolTX = {
    action: WSServerActions.POOL_TX,
    activity,
    poolAddr,
    uuid,
    txHash,
    offChainData,
    chainConfigurationName,
  }
  return JSON.stringify(action)
}

export type WSServerActionBalanceRefresh = WSServerAction & {
  action: WSServerActions.BALANCE_REFRESH
  activity: ActivityEnum
  accountAddr: EthAddr
  chainConfigurationName: string
}

export function wsServerActionBalanceRefresh(
  activity: ActivityEnum,
  accountAddr: EthAddr,
  chainConfigurationName: string
): string {
  const action: WSServerActionBalanceRefresh = {
    action: WSServerActions.BALANCE_REFRESH,
    activity,
    accountAddr,
    chainConfigurationName,
  }
  return JSON.stringify(action)
}

export type WSServerActionClockRefresh = WSServerAction & {
  action: WSServerActions.CLOCK_REFRESH
  activity: ActivityEnum
}

export function wsServerActionClockRefresh(chainConfigurationName: string): string {
  const action: WSServerActionClockRefresh = {
    action: WSServerActions.CLOCK_REFRESH,
    activity: ActivityEnum.CLOCK_REFRESH,
    chainConfigurationName,
  }
  return JSON.stringify(action)
}
